import { action, atom } from '@reatom/framework'

import { Preferences } from '../model'

export const preferencesAtom = atom<Preferences.Preferences>(
  Preferences.initial(),
  'preferencesAtom',
)

export const balanceVisibleAtom = atom(
  (ctx) => !ctx.spy(preferencesAtom).hideBalance,
  'balanceVisibleAtom',
)

export const toggleVisibility = action((ctx) => {
  preferencesAtom(ctx, Preferences.toggleVisibility(ctx.get(preferencesAtom)))
}, 'toggleVisibility')
